import { apiRequest } from "util/services";

function profilePath(profileRef) {
  return encodeURIComponent(String(profileRef || ""));
}

export const listProfiles = ({
  email,
  search,
  filter,
  page = 1,
  pageSize = 25,
} = {}) => {
  const q = new URLSearchParams();
  if (email) q.set("email", email);
  if (search) q.set("search", search);
  if (filter) q.set("filter", filter);
  q.set("page", String(page));
  q.set("page_size", String(pageSize));
  return apiRequest(`customer-365?${q}`, "GET", null, true);
};

export const fetchProfile = (profileRef) =>
  apiRequest(`customer-365/${profilePath(profileRef)}`, "GET", null, true);

export const fetchTimeline = (profileRef, { page = 1, pageSize = 25 } = {}) => {
  const q = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  return apiRequest(
    `customer-365/${profilePath(profileRef)}/timeline?${q}`,
    "GET",
    null,
    true
  );
};

export const fetchRecommendations = (
  profileRef,
  { includeAcked = true } = {}
) => {
  const q = new URLSearchParams({
    include_acked: includeAcked ? "true" : "false",
  });
  return apiRequest(
    `customer-365/${profilePath(profileRef)}/recommendations?${q}`,
    "GET",
    null,
    true
  );
};

export const acknowledgeRecommendation = (profileRef, ruleId) =>
  apiRequest(
    `customer-365/${profilePath(profileRef)}/recommendations/${ruleId}/ack`,
    "POST",
    {},
    true
  );

export const mergeProfiles = (profileRef, otherProfileRef) => {
  const otherRef = String(otherProfileRef ?? "");
  const payload = /^\d+$/.test(otherRef)
    ? { other_profile_id: Number(otherRef) }
    : { other_gpuuid: otherRef };
  return apiRequest(
    `customer-365/${profilePath(profileRef)}/merge`,
    "POST",
    payload,
    true
  );
};

export const startOutreach = (
  profileRef,
  { channel = "whatsapp", message, recommendationRuleId } = {}
) =>
  apiRequest(
    `customer-365/${profilePath(profileRef)}/outreach`,
    "POST",
    {
      channel,
      message,
      recommendation_rule_id: recommendationRuleId,
    },
    true
  );
